import { render, staticRenderFns } from "./FooterMaster.vue?vue&type=template&id=45c59290&"
import script from "./FooterMaster.vue?vue&type=script&lang=js&"
export * from "./FooterMaster.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports